<div id="wrapper">
  <app-loading-screen [status]=true></app-loading-screen>
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    <div style="margin-bottom: 0px;">
      <app-tab-nav (updatePostpaid)="this.postpago=$event" 
        (updatePrepaid)="this.prepago=$event"
        (updateFixed)="this.telefoniaFijo=$event" 
        (updateTotalAccountList)="this.totalAccountList=$event"
        (updateCurrentList)="this.currentList=$event" 
        (updateSelectBan)="this.selectBan=$event"
        (updateInitializeData)="this.initializeData()">
      </app-tab-nav>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="basicrow mbott" *ngIf="this.totalAccountList > 0">
      <div class="container">
        <div class="fulltitle m-top-i f-btitle">
          <span class="icon-dash-01"></span> Historial de pagos
        </div>
        <div class="basicrow m-top">
          <div class="autowcont m-bott">
            <div class="basicrow msidespad border-bottom">
              <div class="b-title noline">
                <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                  <div class="tabcell">
                    Historial de Pagos
                  </div>
                </div>
              </div>
            </div>
            <div class="basicrow">
              <div class="basicrow allpads">
                <div class="basicrow">
                  <div class="autorow subsc pull-left mob-wid">
                    <label class="label-r">Filtro de Busqueda:</label>
                    <div class="basicrow">
                      <div>
                        <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f"
                          style="background-image:url(/assets/images/selectabarrw.png)">
                          <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="autorow subsc pull-left mleft-select " [hidden]="false">
                    <label class="label-r">Año</label>
                    <div class="basicrow">
                      <select (change)="updateBillsPaymentChange()" [(ngModel)]="selectYear" class="sel-f yearSelect"
                        style="background-image:url(/assets/images/selectabarrw.png)">
                        <option disabled value="">Año</option>
                        <option *ngFor="let year of this.yearList" [ngValue]="year">{{year}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="basicrow m-top-i text-justify">
                  Si su pago aparece en estado de <span class="roboto-b">iniciado</span> o <span
                    class="roboto-b">procesado</span>, su pago est&aacute; siendo procesado por nuestro sistema e
                  instituci&oacute;n bancaria. De su pago no ser procesado exitosamente por el banco o nuestro sistema,
                  el mismo ser&aacute; eliminado de nuestro sistema autom&aacute;ticamente. Esta lista s&oacute;lo
                  contiene pagos efectuados los &uacute;ltimos 13 meses.
                </div>
              </div>
              <div class="basicrow msidespad roboto-b f-black f-reg m-bott">
                <div class="basicrow topbord">
                  Factura Actual
                </div>
              </div>
              <div class="basicrow visible-web">
                <div class="tab-tbar">
                  <div class="frwds rline vcenter">
                    <div class="tabcell">
                      Fecha de Facturaci&oacute;n
                    </div>
                  </div>
                  <div class="frwds rline vcenter">
                    <div class="tabcell">
                      M&eacute;todo
                    </div>
                  </div>
                  <div class="frwds rline vcenter">
                    <div class="tabcell">
                      Status
                    </div>
                  </div>
                  <div class="frwds vcenter">
                    <div class="tabcell">
                      Cantidad
                    </div>
                  </div>
                </div>
                <div class="basicrow" *ngFor="let invoiceHistory of this.invoicesHistory; let i = index">
                  <div class="tab-cbar">
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        {{invoiceHistory.Fecha}}
                      </div>
                    </div>
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        {{invoiceHistory.Metodo}}
                      </div>
                    </div>
                    <div class="frwds rline vcenter">
                      <div class="tabcell">
                        {{invoiceHistory.Status}}
                      </div>
                    </div>
                    <div class="frwds vcenter">
                      <div class="tabcell">
                        {{invoiceHistory.Cantidad}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="basicrow m-top visible-movil">
                <div class="basicrow" id="last-div">
                  <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
                    <div class="carousel-inner">
                      <carousel [interval]="false">
                        <slide>
                          <div class="item active">
                            <div class="boxtbl">
                              <div class="tab-tbar">
                                <div class="frwds rline vcenter">
                                  <div class="tabcell">
                                    Fecha de Facturaci&oacute;n
                                  </div>
                                </div>
                                <div class="frwds vcenter">
                                  <div class="tabcell">
                                    M&eacute;todo
                                  </div>
                                </div>
                              </div>
                              <div class="basicrow">
                                <div class="tab-cbar" ng-repeat="bill in vm.bills"
                                  *ngFor="let invoiceHistory of this.invoicesHistory; let i = index">
                                  <div class="frwds rline vcenter">
                                    <div class="tabcell">
                                      {{invoiceHistory.Fecha}}
                                    </div>
                                  </div>
                                  <div class="frwds vcenter">
                                    <div class="tabcell">
                                      {{invoiceHistory.Metodo}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </slide>
                        <slide>
                          <div class="item">
                            <div class="boxtbl">
                              <div class="tab-tbar">
                                <div class="frwds rline vcenter">
                                  <div class="tabcell">
                                    Status
                                  </div>
                                </div>
                                <div class="frwds vcenter">
                                  <div class="tabcell">
                                    Cantidad
                                  </div>
                                </div>
                              </div>
                              <div class="basicrow">
                                <div class="tab-cbar" ng-repeat="bill in vm.bills"
                                  *ngFor="let invoiceHistory of this.invoicesHistory; let i = index">
                                  <div class="frwds rline vcenter">
                                    <div class="tabcell">
                                      {{invoiceHistory.Status}}
                                    </div>
                                  </div>
                                  <div class="frwds vcenter">
                                    <div class="tabcell">
                                      <span class="roboto-b">
                                        {{invoiceHistory.Cantidad}}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </slide>
                      </carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>